import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { variables } from '../../../assets/styles/variables';
import themeColors from '../../../assets/styles/themeColors';
import { ReactComponent as InfoIcon } from '../../../assets/images/svg/info-bg.svg';
import { ReactComponent as CloseIcon } from '../../../assets/images/svg/close.svg';

const InfoPopupWrapper = styled.div`
  border-radius: ${variables.borderRadius.borderRadius};
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.24);
  background-color: ${themeColors.colorWhite};
  position: absolute;
  top: 20px;
  left: 16px;
  right: 16px;
  margin: 0 auto;
  overflow: hidden;
  z-index: 1;
`;

const InfoPopupContent = styled.div`
  position: relative;
  padding: 16px 16px 16px 0;
  display: flex;
  align-items: center;
  flex-grow: 1;

  > svg {
    margin-left: 16px;
    margin-right: 12px;
  }
`;

const InfoPopunPattern = styled.div`
  width: 6px;
  height: 100%;
  position: absolute;
  border-radius: 4px 0 0 4px;
  background-color: ${themeColors.colorTextSecondary};
`;

const CloseIconWrapper = styled.div`
  cursor: pointer;
  width: 14px;
  height: 14px;
  margin-left: auto;
`;

const InfoPopup = ({ children, onClose }) => (
  <InfoPopupWrapper>
    <InfoPopupContent>
      <InfoPopunPattern />
      <InfoIcon />
      {children}
      <CloseIconWrapper onClick={onClose}>
        <CloseIcon />
      </CloseIconWrapper>
    </InfoPopupContent>
  </InfoPopupWrapper>
);

InfoPopup.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func,
};

export default InfoPopup;
